import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// True while the contact section or footer is on screen, so floating CTAs never cover forms/links.
export const useNearSections = (selector = "#contact, footer") => {
  const [near, setNear] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => {
    setNear(false);
    const els = [...document.querySelectorAll(selector)];
    if (!els.length) return undefined;
    const seen = new Set();
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? seen.add(e.target) : seen.delete(e.target)));
      setNear(seen.size > 0);
    }, { rootMargin: "0px 0px -10% 0px" });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [selector, pathname]);
  return near;
};
